import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import makeStyles from '@material-ui/core/styles/makeStyles'
import { Grid, lighten } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'

import StudentInformation from './StudentInformation'
import { organizationActions, userActions } from '../../../_state/actions'
import StudentCourseProgression from './StudentCourseProgression'
import moment from 'moment'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined'
import DialogContent from '@mui/material/DialogContent'
import Button from '@mui/material/Button'
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf'

import CourseViewTopicList from '../../../Components/CourseView/CourseViewTopicList'
import generateCourseProgressionPdf from '../../../Components/CourseView/generateCourseProgressionPdf'
import { DEFAULT_PDF_COLUMN_OPTIONS } from '../../../Components/CourseView/CourseProgressionPdfDocument'
import { UserStatisticsVisibility } from '../CapeeshConstants'
import { FormattedMessage, useIntl } from 'react-intl'
import DialogActions from '@mui/material/DialogActions'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { i18nMessages } from '../../../Logic/CodeAccessible.i18n.Messages'

const useStyles = makeStyles((theme) => ({
    nameField: {
        width: 'auto',
    },
    languageForm: {
        margin: '25px 0px',
        width: '200px',
    },
    nameInput: {
        fontSize: '4rem',
        fontWeight: '200',
        color: theme.palette.primary.main,
    },
    button: {
        margin: theme.spacing(1),
    },
    root: {
        margin: theme.spacing(1),
    },
    topBar: {
        display: 'inline-flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    flag: {},
    wordCloudContent: {
        padding: '30px 15px',
    },
    wordCloud: {
        textAlign: 'center',
    },
    card: {
        height: '185px',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: '#0000003d',
        boxShadow: 'none',
    },
    content: {
        backgroundColor: 'primasarysd',
        alignContent: 'space-evenly',
        height: '-webkit-fill-available',
        display: 'grid',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        marginBottom: 16,
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    courses: {
        display: 'inline-flex',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    rootPanel: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '20%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    tertiaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    progress: {
        width: '200px',
    },
    inline: {
        display: 'inline',
    },
    progressBarParent: {
        position: 'relative',
        width: '40px',
        height: '40px',
    },
    progressBarBackground: {
        position: 'absolute',
        zIndex: 1,
        color: lighten(theme.palette.primary.main, 0.5),
    },
    progressBar: {
        position: 'absolute',
        color: theme.palette.primary.main,
        animationDuration: '550ms',
        zIndex: 1,
    },
    dateRangeHotKey: {
        cursor: 'pointer',
        color: '#888888',
        display: 'inline',
        width: 'fit-content',
        userSelect: 'none',
        '&:hover': {
            color: '#333333',
        },
    },
    avatar: {
        backgroundColor: '#dfdfdf',
        color: '#262626',
        width: '100%',
        height: '100%',
    },
    avatarProgress: {
        width: '80px',
        height: '80px',
        margin: '5px auto',
        position: 'relative',
        overflow: 'visible',
    },
}))

const StudentOverview = (props) => {
    const classes = useStyles()
    const intl = useIntl()
    const { computedMatch } = props

    const userId = computedMatch.params.userId
    const classroomId = computedMatch.params.classroomId

    const [userLoaded, setUserLoaded] = useState(false)

    const [openCourseGroupId, setOpenCourseGroupId] = useState(null)
    const [openCourseGroup, setOpenCourseGroup] = useState(null)
    const [openCourseGroupProgression, setOpenCourseGroupProgression] = useState(null)
    const [openCourseGroupModal, setOpenCoursGroupModal] = useState(false)
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false)
    const [pdfColumnDialogOpen, setPdfColumnDialogOpen] = useState(false)
    const [pdfColumnOptions, setPdfColumnOptions] = useState(DEFAULT_PDF_COLUMN_OPTIONS)

    useEffect(() => {
        props.dispatch(userActions.getUserStats(props.organization.selectedOrganization, userId))
        if (props.user?.userStats?.userId === userId) {
            setUserLoaded(true)
        }
    }, [])

    useEffect(() => {
        if (props.user?.userStats?.userId === userId) {
            setUserLoaded(true)
        }
    }, [props.user.userStats])

    const handleCourseGroupOpen = (courseGroupId) => {
        setOpenCourseGroupId(courseGroupId)

        if (props.user?.userIdToCourseGroupMapper && userId in props.user?.userIdToCourseGroupMapper) {
            const courseGroupToShow = props.user.userIdToCourseGroupMapper[userId].find((x) => x.id === courseGroupId)
            setOpenCourseGroup(courseGroupToShow)

            if (
                userId in props.user.userIdToCourseGroupProgressionMapper &&
                courseGroupToShow.id in props.user.userIdToCourseGroupProgressionMapper[userId]
            ) {
                const courseGroupProgressionToShow =
                    props.user.userIdToCourseGroupProgressionMapper[userId][courseGroupToShow.id]
                setOpenCourseGroupProgression(courseGroupProgressionToShow)
                console.log('courseGroupProgressionToShow', courseGroupProgressionToShow)
            }
        }
        setOpenCoursGroupModal(true)
    }

    const handleCloseCourseGroupModal = () => {
        setOpenCourseGroupId(null)
        setOpenCoursGroupModal(false)
        setOpenCourseGroupProgression(null)
        setOpenCourseGroup(null)
    }

    const handleExportProgression = () => {
        let date = moment(moment.now()).format('YYYY-MM-DD')
        let userName = props.user?.userStats?.name || 'Student'
        let filename = 'Progression ' + userName + ' ' + date + '.xlsx'
        props.dispatch(
            organizationActions.exportCourseGroupProgressionStudent(
                props.organization.selectedOrganization,
                userId,
                filename,
                undefined,
                undefined,
                props.user?.userDashboardLanguageId || 1
            )
        )
    }

    const dashboardLanguageToLocale = { 1: 'en', 3: 'nb', 6: 'de' }

    const currentOrganizationForPdf = props.organization?.myOrganizations?.find(
        (x) => x.id === props.organization?.selectedOrganization
    )
    // Strict organizations never expose the score, so it is not offered in the picker either
    const scoreColumnAvailable = currentOrganizationForPdf?.userStatisticsVisibility !== UserStatisticsVisibility.Strict

    const openPdfColumnDialog = () => {
        if (isGeneratingPdf || !openCourseGroup || !openCourseGroupProgression) return
        setPdfColumnOptions(DEFAULT_PDF_COLUMN_OPTIONS)
        setPdfColumnDialogOpen(true)
    }

    const togglePdfColumn = (optionKey) => {
        setPdfColumnOptions((previous) => ({ ...previous, [optionKey]: !previous[optionKey] }))
    }

    const handleExportCoursePdf = async () => {
        if (isGeneratingPdf || !openCourseGroup || !openCourseGroupProgression) return
        setPdfColumnDialogOpen(false)
        setIsGeneratingPdf(true)
        try {
            const lessonProgressions = props.user?.userIdToLessonProgressionsMapper?.[userId] || []
            const topicLessonOrderIndex = props.topic?.topicLessonOrderIndex || {}
            const locale = dashboardLanguageToLocale[props.user?.userDashboardLanguageId] || 'en'
            const currentOrg = props.organization?.myOrganizations?.find(
                (x) => x.id === props.organization?.selectedOrganization
            )
            const hideScore = currentOrg?.userStatisticsVisibility === UserStatisticsVisibility.Strict
            const orgUser = props.organization?.organizationUsers?.find((x) => x.id === userId)
            const email = orgUser?.email || props.user?.userStats?.email || ''
            const nickName = orgUser?.nickName
            const studentName = nickName ? `${nickName} (${email})` : email || 'Student'

            await generateCourseProgressionPdf({
                courseGroup: openCourseGroup,
                courseGroupProgression: openCourseGroupProgression,
                lessonProgressions,
                topicLessonOrderIndex,
                studentName,
                locale,
                hideScore,
                columnOptions: pdfColumnOptions,
            })
        } catch (err) {
            console.error('PDF generation failed:', err)
        } finally {
            setIsGeneratingPdf(false)
        }
    }

    return (
        <div>
            {openCourseGroupModal && (
                <Dialog maxWidth={'md'} open={openCourseGroupModal} onClose={() => handleCloseCourseGroupModal()}>
                    <div style={{ width: '856px', padding: '16px' }}>
                        <div
                            style={{
                                display: 'flex',
                                width: '100%',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}>
                            <Button
                                onClick={openPdfColumnDialog}
                                disabled={isGeneratingPdf}
                                variant="outlined"
                                size="small"
                                startIcon={isGeneratingPdf
                                    ? <CircularProgress size={16} style={{ color: '#186ED7' }} />
                                    : <PictureAsPdfIcon style={{ fontSize: 18 }} />
                                }
                                style={{
                                    textTransform: 'none',
                                    fontFamily: 'Rubik',
                                    fontSize: 13,
                                    fontWeight: 500,
                                    color: '#186ED7',
                                    borderColor: '#186ED7',
                                    borderRadius: 8,
                                }}>
                                {isGeneratingPdf
                                    ? <FormattedMessage id="student.overview.pdf.generating" defaultMessage="Generating..." />
                                    : <FormattedMessage id="student.overview.pdf.download" defaultMessage="Download PDF" />
                                }
                            </Button>
                            <IconButton
                                onClick={() => handleCloseCourseGroupModal()}
                                style={{ justifyContent: 'flex-end', display: 'flex' }}>
                                <CancelOutlinedIcon style={{ fill: 'black', width: 24, height: 24 }} size="medium" />
                            </IconButton>
                        </div>
                        <DialogTitle className={classes.dialogTitle}>
                            <div className={classes.dialogTitleDiv}>
                                <Typography
                                    variant="h1"
                                    style={{
                                        boxShadow: 'none',
                                        flex: 1,
                                        fontSize: 24,
                                        color: '#35323C',
                                        textAlign: 'center',
                                        alignItems: 'center',
                                        fontFamily: 'Rubik',
                                        fontStyle: 'normal',
                                        fontWeight: 500,
                                        marginBottom: 6,
                                    }}>
                                    {openCourseGroup?.name}
                                </Typography>
                                <div>
                                    <Typography
                                        variant="h1"
                                        style={{
                                            boxShadow: 'none',
                                            flex: 1,
                                            fontSize: 14,
                                            color: '#6E6C71',
                                            textAlign: 'center',
                                            alignItems: 'center',
                                            fontFamily: 'Rubik',
                                            fontStyle: 'normal',
                                            fontWeight: 300,
                                        }}>
                                        {openCourseGroup?.description}
                                    </Typography>
                                </div>
                            </div>
                        </DialogTitle>
                        <div>
                            <DialogContent>
                                <CourseViewTopicList
                                    courseGroup={openCourseGroup}
                                    courseGroupProgression={openCourseGroupProgression}
                                    dispatch={props.dispatch}
                                    userId={userId}
                                    organizationId={props.organization.selectedOrganization}
                                    showPassedOnLessons={true}></CourseViewTopicList>
                            </DialogContent>
                        </div>
                    </div>
                </Dialog>
            )}
            {!userLoaded && (
                <div>
                    <CircularProgress></CircularProgress>
                    Loading user...
                </div>
            )}

            {userLoaded && (
                <Grid container>
                    <Grid item xs={12} style={{ marginLeft: '40px', marginTop: '20px' }}>
                        <StudentInformation
                            userId={userId}
                            classroomId={classroomId}
                            dispatch={props.dispatch}
                            onExportProgression={handleExportProgression}
                            isExportingProgression={props.organization.isExportingStudentProgression}
                        />
                    </Grid>

                    <Grid item xs={8} style={{ marginLeft: '40px', marginTop: '20px' }}>
                        <StudentCourseProgression
                            userId={userId}
                            onCourseGroupOpen={handleCourseGroupOpen}
                            organizationId={props.organization.selectedOrganization}
                            dispatch={props.dispatch}></StudentCourseProgression>
                    </Grid>
                </Grid>
            )}

            <Dialog open={pdfColumnDialogOpen} onClose={() => setPdfColumnDialogOpen(false)} maxWidth="xs" fullWidth>
                <DialogTitle>{intl.formatMessage(i18nMessages.pdfColumnsTitle)}</DialogTitle>
                <DialogContent>
                    <Typography style={{ fontFamily: 'Rubik', fontSize: 14, marginBottom: 8 }}>
                        {intl.formatMessage(i18nMessages.pdfColumnsDescription)}
                    </Typography>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={pdfColumnOptions.includeStatus}
                                    onChange={() => togglePdfColumn('includeStatus')}
                                    color="primary"
                                    size="small"
                                />
                            }
                            label={intl.formatMessage(i18nMessages.pdfColumnStatus)}
                        />
                        {scoreColumnAvailable && (
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={pdfColumnOptions.includeScore}
                                        onChange={() => togglePdfColumn('includeScore')}
                                        color="primary"
                                        size="small"
                                    />
                                }
                                label={intl.formatMessage(i18nMessages.pdfColumnScore)}
                            />
                        )}
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={pdfColumnOptions.includeTime}
                                    onChange={() => togglePdfColumn('includeTime')}
                                    color="primary"
                                    size="small"
                                />
                            }
                            label={intl.formatMessage(i18nMessages.pdfColumnTime)}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={pdfColumnOptions.includeDate}
                                    onChange={() => togglePdfColumn('includeDate')}
                                    color="primary"
                                    size="small"
                                />
                            }
                            label={intl.formatMessage(i18nMessages.pdfColumnDate)}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setPdfColumnDialogOpen(false)}>
                        {intl.formatMessage(i18nMessages.pdfColumnsCancel)}
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleExportCoursePdf}>
                        {intl.formatMessage(i18nMessages.pdfColumnsDownload)}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

StudentOverview.propTypes = {}

const mapToProps = (state) => {
    return {
        organization: state.organization,
        user: state.user,
        metadata: state.metadata,
        usergroup: state.usergroup,
        topic: state.topic,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapToProps, mapDispatchToProps)(StudentOverview)
